/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_ScreenInputs */



/**
* | output |
* | --- |
* | "Full Screen" |
*
* @param {Full_ScreenInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const full_screen = /** @type {((inputs?: Full_ScreenInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_ScreenInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Plein écran")
	if (locale === "de") return /** @type {LocalizedString} */ ("Vollbildmodus")
	if (locale === "it") return /** @type {LocalizedString} */ ("A schermo intero")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Полноэкранный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pantalla completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全屏")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全画面表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्ण स्क्रीन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tela cheia")
	return /** @type {LocalizedString} */ ("Full Screen")
});